<template>
  <div class="listContent">
    <el-row>
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <div class="title">
          <el-breadcrumb
            itemscope
            itemtype="https://schema.org/BreadcrumbList"
            separator-class="el-icon-arrow-right"
            class="breadcrumb"
          >
            <el-breadcrumb-item
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
              :to="{ path: '/' }"
              >Home</el-breadcrumb-item
            >
            <el-breadcrumb-item
              v-for="item in breadcrumb"
              :key="item.id"
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
              :to="{ path: item.path }"
              >{{ item.name }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>

        <div v-if="categoryDetail" class="descriptions">
          <h1>
            {{ breadcrumb[breadcrumb.length - 1].name }}
          </h1>
          <p v-for="(item, index) in categoryDetail.descriptions" :key="index">
            {{ item }}
          </p>
          <h2>
            {{ categoryDetail.title }}
          </h2>
        </div>

        <div v-loading="listLoad">
          <MouldExhibition
            :moulds="listOfCategories"
            :type="type"
            :loose="true"
          />
        </div>
        <h1 v-if="listOfCategories.length == 0 && !listLoad" class="nomore">
          Did not find what you were looking for~
        </h1>
        <div class="pagination">
          <el-pagination
            v-if="total > 12 && !isMobile"
            background
            class="pagination"
            :current-page.sync="pageNum"
            :page-sizes="[12, 24, 36, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
          <el-pagination
            v-if="total > 12 && isMobile"
            small
            :current-page.sync="pageNum"
            :total="total"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>

        <div
          v-if="categoryDetail && categoryDetail.moreAbout"
          class="moreAbout"
          style="margin-bottom: 20px"
        >
          <template v-for="(item, index) in categoryDetail.moreAbout">
            <div :key="index">
              <h2>
                {{ item.title }}
              </h2>
              <div :key="index">
                <p
                  v-for="(docItem, docIndex) in item.documents"
                  :key="docIndex"
                  v-html="docItem"
                ></p>
              </div>
            </div>
          </template>
        </div>

        <div v-if="categoryDetail && categoryDetail.qas" class="qa">
          <h2 class="title">
            {{ breadcrumb[breadcrumb.length - 1].name }} FAQ
          </h2>
          <template v-for="(item, index) in categoryDetail.qas">
            <div :key="index">
              <h3>
                {{ item.q }}
              </h3>
              <p style="white-space: pre-line">
                {{ item.a }}
              </p>
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
    <el-row class="inquiry-form" style="margin: 0" :gutter="20">
      <el-col
        :xs="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :md="{ span: 18, offset: 3 }"
        :lg="{ span: 16, offset: 4 }"
      >
        <h2 class="title">Product Inquiry</h2>
        <p class="desc">
          Email us if you are interested in
          {{ breadcrumb[breadcrumb.length - 1].name }}. We would be happy to
          answer your questions.
        </p>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input v-model="quotation.name" placeholder="*Name"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input v-model="quotation.email" placeholder="*Email"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input
            v-model="quotation.businessPhoneNumber"
            placeholder="*Phone"
          ></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12">
          <el-input
            v-model="quotation.estimatedOrderQuantity"
            placeholder="Order Quantity"
          ></el-input>
        </el-col>
        <el-col :span="24">
          <el-input
            v-model="quotation.requirements"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="Content"
          ></el-input>
        </el-col>
        <el-col :span="24">
          <el-button
            type="primary"
            :loading="submmiting"
            class="submit-btn"
            @click="submmit"
          >
            submit
          </el-button>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MouldExhibition from "@/components/ProductsItem/MouldExhibition";
import { palFormUrl } from "../../config/appConfig";
import { customFetch } from "../../utils/api";
import { mapGetters } from "vuex";
import categoryDetails from "./categoryDetails";
import { retryTips } from "../../static/staticText";
export default {
  name: "ProductsList",
  components: {
    MouldExhibition,
  },
  data() {
    return {
      quotation: {},
      submmiting: false,
      searchKey: "",
      selectType: 0,
      type: "",
      total: 0,
      pageNum: 1,
      pageSize: 12,
      listOfCategories: [],
      name: "",
      categoryId: "",
      propsOption: {
        value: "id",
        label: "name",
        children: "internationalProductsCategoryList",
        expandTrigger: "hover",
        checkStrictly: true,
      },
      // categoryOptions: [],
      listLoad: false,
      breadcrumb: [{ name: "Home", path: "/" }],
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    categoryName() {
      return this.name
        .split("-")
        .map((item) => item.replace(/^[a-z]/g, (L) => L.toUpperCase()))
        .join(" ");
    },
    categoryDetail() {
      return categoryDetails[this.$route.params.id] || null;
    },
  },
  async mounted() {
    this.name = this.$route.params.category;
    this.categoryId = this.$route.params.id;
    this.getAllCategory();
    await this.getProductsByCategory();
    this.getBreadcrumb(this.$route.params.id);
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.category.includes("service")) {
      this.$router.push("/home/after-sale-service");
    } else {
      next((vm) => {
        console.log(
          "id+++++++++++++",
          to.params.id,
          localStorage.getItem("categoryId")
        );
        if (
          from.name == "product-detail" &&
          to.params.id == localStorage.getItem("categoryId")
        ) {
          vm.pageNum = Number(localStorage.getItem("pageNum"));
          vm.pageSize = Number(localStorage.getItem("pageSize"));
        }
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.category.includes("service")) {
      this.$router.push("/home/after-sale-service");
    } else {
      next();
      this.pageNum = 1;
      const { category, id } = to.params;
      if (category && id) {
        localStorage.curCategoryName = category;
        localStorage.curCategoryId = id;
        this.name = category;
        this.categoryId = id;
      } else {
        this.name = localStorage.curCategoryName;
        this.categoryId = localStorage.curCategoryId;
      }
      this.getProductsByCategory();
      this.getBreadcrumb(id);
    }
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem("pageNum", this.pageNum);
    localStorage.setItem("pageSize", this.pageSize);
    localStorage.setItem("categoryId", this.categoryId);
    next();
  },
  methods: {
    getAllCategory() {
      let allCatego = JSON.parse(localStorage.allCategories);
      console.log("allCatego");
      if (allCatego.length > 0) {
        allCatego.forEach((item, index) => {
          this.goLevelCate(item, index);
        });
        this.categoryOptions = allCatego;
        return;
      }
      customFetch(
        `${palFormUrl}/international/getInternationalProductsCategoryList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: 0,
          }),
        },
        (res) => {
          res.result.forEach((item, index) => {
            this.goLevelCate(item, index);
          });
          this.categoryOptions = res.result;
          console.log(this.categoryOptions);
        },
        () => {}
      );
    },
    getBreadcrumb(id) {
      customFetch(
        `${palFormUrl}/international/getInternationalProductsCategoryListById?id=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
        (res) => {
          const categoryInfo = res.result.find((x) => x.id == id);

          console.log("categoryInfo:", categoryInfo);

          if (categoryInfo && categoryInfo.title) {
            document.title = categoryInfo.title;
          }
          if (categoryInfo && categoryInfo.keywords) {
            document
              .querySelector("meta[name='keywords']")
              .setAttribute("content", categoryInfo.keywords);
          }
          if (categoryInfo && categoryInfo.content) {
            document
              .querySelector("meta[name='description']")
              .setAttribute("content", categoryInfo.description);
          }

          this.breadcrumb = res.result.map((item) => {
            return {
              name: item.name,
              path: `/products-list/${item.name
                .split(" ")
                .map((it) => it.toLowerCase())
                .join("-")}/${item.id}`,
            };
          });

          const structureScript = document.getElementById("structureData");
          structureScript.type = "application/ld+json";
          const structureData = {
            "@context": "https://schema.org",
            "@type": "ItemList",
            url: window.location.href,
            name: categoryInfo.name,
            description: categoryInfo.description,
          };
          structureData.itemListElement = this.listOfCategories.map(
            (item, index) => {
              return {
                "@type": "ListItem",
                position: index,
                item: {
                  "@type": "Product",
                  name: item.name,
                },
              };
            }
          );
          structureScript.innerText = JSON.stringify(structureData);

          const breadcrumb = document.getElementById("breadcrumb");
          const breadcrumbData = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
          };

          breadcrumbData.itemListElement = res.result.map((item, index) => {
            return {
              "@type": "ListItem",
              position: index,
              item: {
                "@id": `https://hic.cosmoplat.com/products-list/${item.name
                  .split(" ")
                  .map((it) => it.toLowerCase())
                  .join("-")}/${item.id}`,
                name: item.name,
              },
            };
          });

          breadcrumb.innerText = JSON.stringify(breadcrumbData);
        },
        () => {}
      );
    },
    goLevelCate(item, index) {
      if (item.internationalProductsCategoryList.length > 0) {
        item.internationalProductsCategoryList.forEach((sub, index) => {
          this.goLevelCate(sub, index);
        });
      } else {
        delete item.internationalProductsCategoryList;
      }
    },
    categoryCascaderChange(item) {
      let obj = this.$refs.categorycascader.getCheckedNodes();
      if (obj.length > 0) {
        this.name = obj[0].label;
        this.categoryId = obj[0].value;
        this.$router.push(
          `/products-list/${this.name
            .split(" ")
            .map((item) => item.toLowerCase())
            .join("-")}/${this.categoryId}`
        );
      }
    },
    submmit() {
      const self = this;
      if (!this.quotation.name) {
        this.$message.error("name is required!");
        return;
      }

      if (!this.quotation.email) {
        this.$message.error("email is required!");
        return;
      }

      if (!this.quotation.businessPhoneNumber) {
        this.$message.error("Phone is required!");
        return;
      }

      if (
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.quotation.email
        )
      ) {
        this.$message.error("Please input a valid email!");
        return;
      }

      this.submmiting = true;
      let params = {
        ...this.quotation,
        productName: "",
        mouldCategory: this.breadcrumb.map((item) => item.name),
      };
      console.log("params", params);
      customFetch(
        `${palFormUrl}/hicPlatform/createHicQuotation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(params),
        },
        () => {
          this.$message.success(
            "Thanks for your inquiry,we'll contact you ASAP."
          );
          this.submmiting = false;
          this.quotation = {};
        },
        () => {
          this.submmiting = false;
          self
            .$confirm(retryTips, "FAILED", {
              confirmButtonText: "Try Again",
              cancelButtonText: "Cancel",
              type: "error",
            })
            .then(() => {
              self.submmit();
            })
            .catch(() => {});
        }
      );
    },
    getProductsByCategory() {
      this.listOfCategories = [];
      this.listLoad = true;
      return new Promise((resolve, reject) => {
        customFetch(
          `${palFormUrl}/international/getInternationalProductsByCategoryId`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              categoryId: this.categoryId || 0,
              pageNum: this.pageNum,
              pageSize: this.pageSize,
            }),
          },
          (res) => {
            this.listLoad = false;
            this.listOfCategories = res.result.list;
            this.total = res.result.total;
            window.scrollTo(0, 0);
            resolve();
          },
          () => {
            this.listLoad = false;
            reject();
          }
        );
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getProductsByCategory();
    },
    handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getProductsByCategory();
    },
  },
};
</script>

<style lang="scss" scoped>
.listContent {
  background-color: #f2f3f7;
}

.title {
  text-align: left;
  padding-bottom: 0;

  .breadcrumb {
    line-height: 30px;
    padding-top: 20px;
  }
}

.pagination {
  padding: 20px 0;
}

.nomore {
  font-size: 20px;
  color: #999;
}

.descriptions {
  text-align: left;
  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 2rem;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
  }
}

.qa {
  text-align: left;
  h3 {
    margin: 0;
    padding: 0;
    font-size: 1.3em;
  }
  p {
    margin: 0;
    padding: 0.5rem 0 1.5rem;
  }

  .title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
}

.moreAbout {
  text-align: left;
  h2 {
    margin: 0;
    padding: 0;
    line-height: 40px;
    font-size: 1.3em;
  }
  p {
    margin: 0;
    line-height: 25px;
  }

  strong {
    font-size: 1em;
  }
}

.inquiry-form {
  background-image: url("../../assets/inquiry-bg.jpg");
  text-align: left;
  padding: 2rem 0;
  margin-top: 1rem;

  .title {
    color: #0084ff;
    font-size: 2rem;
    text-align: left;
  }

  .el-col {
    padding: 0.5rem 0;
  }

  .el-input__inner {
    border-radius: 0px;
    background-color: rgba(14, 39, 91, 0.6);
    border: none;
    color: white;
  }

  .el-textarea__inner {
    @extend .el-input__inner;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
  }

  .submit-btn {
    border-radius: 0px;
    width: 100%;
    background-color: rgba(0, 132, 255, 1);
  }

  .desc {
    color: white;
  }
}
</style>
